import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class ModalEffects {

  constructor(private readonly actions: Actions) {

  }

}
